/* Hey Hottie - one honest signal that the cart changed.
 *
 * The problem this exists to solve: Stiletto's quantity stepper changes the
 * cart without dispatching any event we can hear. Every widget that reads the
 * cart - the free shipping bar, the third-item nudge - was listening for
 * events like 'cart:updated' that the stepper never fires, so they sat there
 * showing the previous cart. A bar that says "$23.00 away from free shipping"
 * on a cart that already qualifies is worse than no bar.
 *
 * Rather than guess at more event names, watch the only thing that cannot
 * lie: the requests. Every cart mutation in Shopify goes through
 * /cart/add|change|update|clear.js, whoever sends it. We wrap fetch and
 * XMLHttpRequest, pass everything through untouched, and dispatch one
 * 'hh:cart-changed' when a mutation finishes.
 *
 * Load this before the widgets. They already listen for that event.
 */
(function () {
  'use strict';

  var MUTATES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var timer = null;

  function announce() {
    /* Shopify has answered, but the theme may still be repainting off the
       same response. A short debounce means one event after the dust settles
       rather than three during. */
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      document.dispatchEvent(new CustomEvent('hh:cart-changed'));
    }, 120);
  }

  function urlOf(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  /* ── fetch ─────────────────────────────────────────────────────────────── */

  if (window.fetch) {
    var realFetch = window.fetch;
    window.fetch = function (input, init) {
      var out = realFetch.apply(this, arguments);
      var url = urlOf(input);
      if (MUTATES.test(url)) {
        out.then(function (res) { if (res && res.ok) announce(); }, function () {});
      }
      return out;
    };
  }

  /* ── XMLHttpRequest ────────────────────────────────────────────────────── */

  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var realOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__hhCart = MUTATES.test(String(url || ''));
      } catch (e) {
        this.__hhCart = false;
      }
      return realOpen.apply(this, arguments);
    };

    var realSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__hhCart) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) announce();
        });
      }
      return realSend.apply(this, arguments);
    };
  }
})();
